import store from "@/store"

import Vue from "vue"
export const emitter = new Vue()

/**
 * generates supports svgs registration entries
 * @returns {Object} - supports registration
 * to be fetched asynchronously
 */
export const getSupportsSVGs = () => {
  const supportsSVGs = {}
  Object.entries(store.state.supports.icons).forEach(([key, val]) => {
    supportsSVGs[`support-${key}`] = () => import(`@/assets/svg/${val}.svg`)
  })
  return supportsSVGs
}

export const FR_MONTHS = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre"
]

/**
 * CURRENT and NEXT month date objects
 */
const dates = (() => {
  let d = new Date()
  // For quick tests
  //d = new Date(d.getFullYear(), d.getMonth(), 23);

  // get 10th of current month
  const d10th = new Date(d.getFullYear(), d.getMonth(), 10)
  // get 10th of next month
  const n10th = new Date(d.getFullYear(), d.getMonth() + 1, 10)
  // get 20th of current month
  const d20th = new Date(d.getFullYear(), d.getMonth(), 20)
  // get 1st of current month
  const d1st = new Date(d.getFullYear(), d.getMonth(), 1)
  // get 1st of next month
  const n1st = new Date(d.getFullYear(), d.getMonth() + 1, 1)

  if (d <= d10th && d >= d1st) {
    return {
      TOVALID: d,
      DEADLINE: d
    }
  }
  if (d >= d20th && d < n1st) {
    return {
      TOVALID: n1st,
      DEADLINE: n10th
    }
  }
})()

/**
 * Validation banner message markup
 */
const VALIDATION_MESSAGE_MARKUP = (() => {
  if (!dates) return
  const _v = dates.TOVALID
  const _d = dates.DEADLINE
  const monthToValid = FR_MONTHS[_v.getMonth()]
  const deadlineMonth = FR_MONTHS[_d.getMonth()]

  // we check if month starts with a vowel (in this case 'Avril' so only 'a')
  // so that we can show "d'Avril" instead of "de Avril"
  const startsWithVowel = monthToValid[0].toLowerCase() === "a"
  return `Attention, vous n'avez que jusqu'au \
          <span>10 ${deadlineMonth}</span> pour \
          valider vos listes de diffusion du mois \
          ${startsWithVowel ? "d'" : "de "}${monthToValid}`
})()

export const planningValidation = {
  dates,
  message: VALIDATION_MESSAGE_MARKUP
}

/**
 * Formats date object to yyyy-mm-dd or dd-mm-yyyy
 * @param {Object} dateObj - date object to format
 * @param {Boolean} yearFirst - whether year should come
 * first or last (defaults to true)
 * @returns {String} - Formatted date string
 */
export const formatTime = (dateObj, yearFirst = true) => {
  const day = ("0" + dateObj.getDate()).slice(-2)
  const month = ("0" + (dateObj.getMonth() + 1)).slice(-2)
  const year = dateObj.getFullYear()
  return yearFirst ? `${year}-${month}-${day}` : `${day}-${month}-${year}`
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}
